import * as React from 'react';

import slider from '../../../assets/img/track.jpg';

export interface IDisplaySlider {}

export default function DisplaySlider(props: IDisplaySlider) {
  return (
    <div className='mt-10'>
      <img src={slider} alt='' className='w-full' />
    </div>
  );
}
